import type { VideoCardData } from "@/fixtures/video/home/fixtures";

/**
 * 財經視頻 filters.
 *
 * 論盡熱話 is here because the /video hero's breadcrumb reads 財經 › 論盡熱話 and
 * QA asked that crumb to open this listing with the tab already selected — a
 * tab the rows never used would have selected an empty grid.
 */
export const tabOptions = ["全部", "市場信析", "論盡熱話"] as const;

export type TabOption = (typeof tabOptions)[number];

// All videos under the finance hub roll up to 市場信析 — additional sub-tabs
// were dropped per the new IA. Padded out to 12 items so the 4-column grid
// has 3 fully filled rows.
export const financeListingVideos: VideoCardData[] = [
  {
    category: "市場信析",
    date: "12分鐘前",
    title: "林少陽：金非避險資產 買金不如買金礦股",
    duration: "08:24",
    img: "/images/video-home/finance-1.png",
  },
  {
    category: "市場信析",
    date: "1天前",
    title: "譚新強﹕中國消費力弱 谷內需談何容易？！",
    duration: "08:24",
    img: "/images/video-home/finance-2.png",
  },
  {
    category: "市場信析",
    date: "3天前",
    title: "看清三大趨勢 2026宜攻不宜守｜信報龍稱專欄",
    duration: "08:24",
    img: "/images/video-home/finance-3.png",
    subscriberOnly: true,
  },
  {
    category: "市場信析",
    date: "8天前",
    title: "AI泡沫瀕爆破？英Sir教分辨真假AI股",
    duration: "08:24",
    img: "/images/video-finance/ai-bubble.png",
  },
  {
    category: "論盡熱話",
    date: "1天前",
    title: "滙豐劉紹文：2026炒股不炒市 推升恒指2大關鍵",
    duration: "08:24",
    img: "/images/video-finance/huisheng-2026.png",
  },
  {
    category: "論盡熱話",
    date: "3天前",
    title: "防2026年3大黑天鵝 教你穩陣投資",
    duration: "08:24",
    img: "/images/video-finance/black-swans.png",
  },
  {
    category: "市場信析",
    date: "3天前",
    title: "林少陽﹕美股科企獨大 不代表牛市有病",
    duration: "08:24",
    img: "/images/video-finance/lam-us-stocks.png",
  },
  {
    category: "論盡熱話",
    date: "5天前",
    title: "杜比Sir﹕大家樂3度盈警 歸因3大致命傷",
    duration: "08:24",
    img: "/images/video-finance/toby-sir.png",
    subscriberOnly: true,
  },
  {
    category: "論盡熱話",
    date: "7天前",
    title: "李聲揚﹕換債吊命 新世界債路漫長",
    duration: "08:24",
    img: "/images/video-finance/lee-debt.png",
    subscriberOnly: true,
  },
  {
    category: "市場信析",
    date: "9天前",
    title: "美元再走弱 港元拆息倒掛 投資者點部署？",
    duration: "08:24",
    img: "/images/video-home/finance-1.png",
  },
  {
    category: "市場信析",
    date: "10天前",
    title: "高息股最後一波？三隻港股值得收藏",
    duration: "08:24",
    img: "/images/video-home/finance-2.png",
    subscriberOnly: true,
  },
  {
    category: "市場信析",
    date: "12天前",
    title: "回看 2025：恒指 V 形反彈 啟示散戶七大規律",
    duration: "08:24",
    img: "/images/video-home/finance-3.png",
  },
];
